<template>
  <div v-if="values && values.length" class="ratings">
    <div class="rating__schema"></div>
    <div>
      <div v-for="(review, index) in paginatedReviews" :key="`Review::${index}`" class="rating__reviews">
        <div class="rating__review--schema">
          <client-only>
            <star-rating
              :inline="true"
              :star-size="20"
              :read-only="true"
              :show-rating="false"
              :rating="review.vote_value"
              :increment="0.5"
              class="rating__review-rating"
            ></star-rating>
          </client-only>
        </div>

        <div class="rating__review--head">
          Review by <strong>{{ $options.filters.sanitize(review.nickname) }}</strong>
        </div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="rating__review--detail" v-html="$options.filters.sanitize(review.details)"></div>
      </div>
    </div>
    <div v-if="pageCount > 1" class="pagination-container" aria-label="Reviews page navigation">
      <client-only>
        <paginate
          v-model="currentPage"
          :page-count="pageCount"
          :page-range="3"
          :margin-pages="0"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination justify-content-center'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          :click-handler="handlePageChange"
        >
        </paginate>
      </client-only>
    </div>
  </div>
</template>

<script>
import xss from 'xss'
export default {
  name: 'PDPReviewsPaginated',
  serverCacheKey: props => `PDPReviewsPaginated::${props.id}`,
  filters: {
    sanitize(value) {
      if (!value) {
        return ''
      }
      return xss(value)
    }
  },
  props: {
    values: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    id: {
      type: String,
      required: false,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: parseInt(this.$config.PDPReviewsPageSize)
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.values.length / this.pageSize)
    },
    paginatedReviews() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.values.slice(start, start + this.pageSize)
    }
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page
    }
  }
}
</script>

<style lang="scss" scoped>
.rating {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  &__review-rating {
    margin: 5px 0;
  }
  &__reviews {
    margin-bottom: 20px;
  }
}
.pagination-container {
  display: flex;
  justify-content: center;

  paginate {
    list-style-type: none;
    display: flex;
    margin-top: 1.5rem !important;
    li {
      list-style-type: none;
      max-height: 24px;
    }
  }

  .btn {
    border: 1px solid #dee2e6;
    &:hover {
      z-index: 2;
      color: $navLinkHighlightColor;
      text-decoration: none;
      background-color: #e9ecef;
      border-color: #dee2e6;
    }
  }
  .pagination {
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
    justify-content: center;
  }
}
</style>
